import React from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import "./Industries.css";
import updated_usecase_1 from "../../Assets/svgs/updated_usecase-1.svg";
import updated_usecase_2 from "../../Assets/svgs/updated_usecase-2.svg";
import updated_usecase_3 from "../../Assets/svgs/updated_usecase-3.svg";
import updated_usecase_4 from "../../Assets/svgs/usecase_4.svg";
import updated_usecase_5 from "../../Assets/svgs/updated_usecase-5.svg";
import updated_usecase_6 from "../../Assets/svgs/updated_usecase-6.svg";
import "../../Pages/LandingPage/LandingPage.css";

function Industries() {
  const industries = [
    {
      title: "Restaurants",
      description:
        "Promote new deals and boost sales with dynamic content management across regions.",
      imgSrc: updated_usecase_1,
      alt: "Digital signage screen on restaurant showing restaurant menu",
    },
    {
      title: "Hospitals",
      description:
        "Attract customers with digital screen ads using real-time RSS tickers for the latest offers and news.",
      imgSrc: updated_usecase_2,
      alt: "Digital signage screen in hospital waiting area showing doctor panel",
    },
    {
      title: "Offices",
      description:
        "Show event-based info to employees, clients, and customers, synced easily with our CMS.",
      imgSrc: updated_usecase_3,
      alt: "Digital signage screen in office showing conference details",
    },
    {
      title: "Retail",
      description:
        "Manage screens easily. Showcase products, offers, or campaigns with cloud content management.",
      imgSrc: updated_usecase_4,
      alt: "Digital signage screen in shopping mall showing summer sale banner",
    },
    {
      title: "Education",
      description:
        "Keep students and staff updated with dynamic displays for announcements, schedules, and events.",
      imgSrc: updated_usecase_5,
      alt: "Student reading digital signage screen showing latest updates",
    },
    {
      title: "Transport",
      description:
        "Broadcast information and updates related to schedules for buses, trains, and other modes of transport for travelers.",
      imgSrc: updated_usecase_6,
      alt: "Two digital signage screens displaying train timings and information in train station",
    },
  ];

  return (
    <section id="Industries">
      <Container>
        <Row>
          <Col md={12}>
            <div className="section-title">
              <h2 className="second_text " style={{ marginBottom: "-1rem" }}>
                Digital signage{" "}
                <span className="first_text">for every industry</span>
              </h2>
            </div>
          </Col>
        </Row>

        {/* For screens > 991px: 2 rows with 3 cards each */}
        <Row
          className="d-none d-lg-flex card-container"
          style={{ marginBottom: "-3.5rem", marginTop: "-1.5rem" }}
        >
          {industries.map((industry, index) => (
            <Col lg={4} key={index}>
              <Card className="mb-5">
                <Card.Img
                  variant="top"
                  src={industry.imgSrc}
                  alt={industry.alt}
                  className="cardimg"
                />
                <Card.Body style={{ width: "90%", marginInline: "auto" }}>
                  <h3 className="cardtitle">{industry.title}</h3>
                  <Card.Text className="carddescription">
                    {industry.description}
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>

        {/* For screens between 767px and 991px: 4 rows */}
        <Row className="d-lg-none">
          <Col md={6} sm={12}>
            <Card className="mb-4">
              <Card.Img
                variant="top"
                src={industries[0].imgSrc}
                alt={industries[0].alt}
              />
              <Card.Body className="mt-3">
                <h3 className="cardtitle">{industries[0].title}</h3>
                <Card.Text className="carddescription">
                  {industries[0].description}
                </Card.Text>
              </Card.Body>
            </Card>
          </Col>
          <Col md={6} sm={12}>
            <Card className="mb-4">
              <Card.Img
                variant="top"
                src={industries[1].imgSrc}
                alt={industries[1].alt}
              />
              <Card.Body className="mt-3">
                <h3 className="cardtitle">{industries[1].title}</h3>
                <Card.Text className="carddescription">
                  {industries[1].description}
                </Card.Text>
              </Card.Body>
            </Card>
          </Col>
        </Row>

        <Row className="d-block d-lg-none">
          <Col md={6}>
            <Card className="mb-4">
              <Card.Img
                variant="top"
                src={industries[2].imgSrc}
                alt={industries[2].alt}
              />
              <Card.Body className="mt-3">
                <h3 className="cardtitle">{industries[2].title}</h3>
                <Card.Text className="carddescription">
                  {industries[2].description}
                </Card.Text>
              </Card.Body>
            </Card>
          </Col>
        </Row>

        <Row className="d-lg-none">
          <Col md={6} sm={12}>
            <Card className="mb-4">
              <Card.Img
                variant="top"
                src={industries[3].imgSrc}
                alt={industries[3].alt}
              />
              <Card.Body className="mt-3">
                <h3 className="cardtitle">{industries[3].title}</h3>
                <Card.Text className="carddescription">
                  {industries[3].description}
                </Card.Text>
              </Card.Body>
            </Card>
          </Col>
          <Col md={6} sm={12}>
            <Card className="mb-4">
              <Card.Img
                variant="top"
                src={industries[4].imgSrc}
                alt={industries[4].alt}
              />
              <Card.Body className="mt-3">
                <h3 className="cardtitle">{industries[4].title}</h3>
                <Card.Text className="carddescription">
                  {industries[4].description}
                </Card.Text>
              </Card.Body>
            </Card>
          </Col>
        </Row>

        <Row className="d-block d-lg-none">
          <Col md={6}>
            <Card>
              <Card.Img
                variant="top"
                src={industries[5].imgSrc}
                alt={industries[5].alt}
              />
              <Card.Body className="mt-3">
                <h3 className="cardtitle">{industries[5].title}</h3>
                <Card.Text className="carddescription">
                  {industries[5].description}
                </Card.Text>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Industries;
